import { Minus, Plus } from "lucide-react";
import React, { useState } from "react";

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question:
        "How does Easy Hiring differ from traditional staffing agencies?",
      answer:
        "We don't just place candidates; we take ownership of their performance. Our engineers are on our payroll, trained by us, and we manage their delivery, acting as your extended engineering arm.",
    },
    {
      question: "Can I hire a dedicated team for a long-term project?",
      answer:
        "Yes, we specialize in building dedicated teams that integrate seamlessly with your existing processes. You can scale the team up or down based on your project needs.",
    },
    {
      question: "What technology stacks do you support?",
      answer:
        "We have expertise in a wide range of technologies including AI/ML, Full Stack (React, Node, Java, Python), Data Engineering, Salesforce, Automation Testing, and more.",
    },
    {
      question: "Do you offer project-based delivery?",
      answer:
        "Absolutely. We can take complete ownership of a project, from requirements gathering to deployment and maintenance, ensuring delivery on time and within budget.",
    },
    {
      question: "How quickly can you deploy resources?",
      answer:
        "We have a strong pipeline of pre-vetted, trained engineers ready to deploy. Typically, we can onboard resources within 1-2 weeks depending on the specific skill requirements.",
    },
  ];

  return (
    <section id="faq" className="py-24 bg-white">
      <div className="container mx-auto px-4 max-w-3xl">
        <div className="text-center mb-16">
          <span className="bg-gray-100 text-gray-700 text-sm font-bold px-4 py-2 rounded-full uppercase tracking-wider mb-6 inline-block">
            Common Questions
          </span>
          <h2 className="text-4xl font-bold text-gray-900 mb-6">
            Understanding our model
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Everything you need to know about partnering with Easy Hiring.
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-gray-50 rounded-2xl border border-gray-200 overflow-hidden transition-all duration-300 hover:bg-white hover:shadow-md"
            >
              <button
                className="w-full flex items-center justify-between p-6 text-left focus:outline-none"
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
              >
                <span className="text-lg font-semibold text-gray-900 pr-8">
                  {faq.question}
                </span>
                {openIndex === index ? (
                  <Minus className="w-5 h-5 text-blue-600 flex-shrink-0" />
                ) : (
                  <Plus className="w-5 h-5 text-gray-400 group-hover:text-blue-600 transition-colors flex-shrink-0" />
                )}
              </button>

              <div
                className="grid transition-all duration-300 ease-in-out"
                style={{
                  gridTemplateRows: openIndex === index ? "1fr" : "0fr",
                }}
              >
                <div className="overflow-hidden">
                  <div className="px-6 pb-6 pt-4 text-gray-600 leading-relaxed">
                    {faq.answer}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
